import { Menu, Button } from '@oliasoft-open-source/react-ui-library';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { languageList } from 'client/internationalization/language-list';

export const LanguagePicker = () => {
  const { i18n } = useTranslation();
  const initLanguage = 'en';
  const [lang, setLang] = useState(initLanguage);

  useEffect(() => {
    async function setLanguage() {
      await i18n.changeLanguage(initLanguage);
    }
    setLanguage();
  }, []);

  const onChangeLanguage = async (language: string) => {
    await i18n.changeLanguage(language);
  };

  const onChangeHandler = (value: string) => {
    setLang(value);
    const updatedLanguage = value;
    onChangeLanguage(updatedLanguage);
  };

  return (
    <Menu
      offset={10}
      menu={{
        trigger: 'Component',
        component: <Button label={lang.toUpperCase()} round />,
        sections: languageList.map((item, ix) => ({
          type: 'Option',
          label: item.label,
          onClick: () => onChangeHandler(item.value),
          selected: item.value === lang,
          testId: `translation-picker-list-${ix}`,
        })),
        placement: 'bottom-end',
      }}
      testId="translation-picker"
    />
  );
};
